import React from "react";

import { Dropdown } from "@packages/ds";

import { sendPendoEventDropdown } from "Store/analytics/pendoFunctions";

import type { DropdownRootProps } from "@packages/ds";

interface ConsoleDropdownRootProps extends DropdownRootProps {
  id?: string;
}

/**
 * Root component for the Dropdown menu system
 *
 * @param props - The component props
 * @returns A Dropdown Root component
 */
const Root = ({
  modal = false,
  id,
  children,
  onOpenChange,
  ...props
}: ConsoleDropdownRootProps) => {
  return (
    <Dropdown.Root
      modal={modal}
      {...props}
      onOpenChange={open => {
        // Send Pendo event when dropdown opens/closes
        sendPendoEventDropdown(id);

        if (onOpenChange) {
          onOpenChange(open);
        }
      }}
    >
      {children}
    </Dropdown.Root>
  );
};

export default Root;
